<template>
	<div id="markerinfo">
		<div class="nav">
		  <div v-on:click="change_nav('info')" v-bind:class="{active:nav_type == 'info'}">详情</div>
		  <div v-on:click="change_nav('carfull')" v-bind:class="{active:nav_type == 'carfull'}">注意事项</div>
		</div>
		<div class="moni info " v-if="nav_type == 'info'">
		  <div v-html="marker.info"></div>
		</div>
		<div class="moni carfull" v-if="nav_type == 'carfull'">
		  <div v-html="marker.content"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Markerinfo',
	data () {
		return {
			marker:{},
			nav_type:'info'
		}
	},
	created (){
		this.$https.post('/api/marker/index',this.$qs.stringify({
			token:this.$store.state.token
		})).then((res) => {
			this.marker = res.data.data.marker
		}).catch((res) => {
			console.log('请求失败');
		})
	},
	methods : {
		change_nav(i){
			this.nav_type = i
		}
	}
}
</script>
<style scoped>
	#markers{
		background-color:#FFFFFF;
		min-height:100vh;
	}
	.nav{
	  height:13vw;
	  background-color:#FFFFFF;
	  display:flex;
	  box-shadow:0px 0px 5px #CCCCCC;
	  border-bottom:1px solid #eeeeee;
	}
	.nav div{
	  flex:1;
	  line-height:13vw;
	  text-align:center;
	  color:#7D7D7D;
	  font-size:4vw;
	  background-image:-webkit-gradient(radial, 50% 50%, 250, 50% 50%, 30, from(#FFFFFF), to(#EEEEEE), color-stop(50%, #FFFFFF));
	}
	.nav div:first-child{
	  border-right:1px solid #EEEEEE;
	}
	.nav div.active{
	  background-image:none;
	  background-color:#FFFFFF;
	}
	.moni{
	  background-color:#FFFFFF;
	  padding:3vw;
	  font-size:3.7vw;
	}
	.moni image{
	  max-width:100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/Markerinfo.vue